import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {SwalComponent} from '@sweetalert2/ngx-sweetalert2';
import {AuthenticateService} from '../services/authenticate.service';
import {NgxSpinnerService} from 'ngx-spinner';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {
  @ViewChild('closeCreateModal') closeCreateModal: ElementRef;
  @ViewChild('closeUpdateModal') closeUpdateModal: ElementRef;
  @ViewChild('errorSwal') private errorSwal: SwalComponent;
  @ViewChild('successSwal') private successSwal: SwalComponent;
  public searchText;
  public users = [];
  public selectedId;
  public adminUser;
  public selectedUser = {name: '', _id: '', username: '', password: '', isTfa: ''};
  constructor(private authenticateService: AuthenticateService,
              private router: Router,
              private spinner: NgxSpinnerService) {

     this.adminUser = JSON.parse(localStorage.getItem('user'));
 /*   if (this.adminUser.status !== 0) {
      this.router.navigate(['/']);
    } */
  }

  ngOnInit() {
    this.getUsers();
    console.log(this.adminUser);
  }

  create(name, username , password, gender, tfa) {
    if (username === '' || username === undefined ||
        password === '' || password === undefined ||
        name === '' || name === undefined || gender === '-1') {
      this.errorSwal.title = 'Lütfen boş alan bırakmayınız!';
      this.errorSwal.show();
      return;
    }
    const data = {
      username: username,
      password: password,
      name: name,
      gender: parseInt(gender),
      isTfa: tfa !== 'false'
    };
    this.authenticateService.register(data).subscribe(res => {
      this.successSwal.title = 'Kayıt başarıyla yapıldı!';
      this.successSwal.show();
      this.closeCreateModal.nativeElement.click();
      this.getUsers();
    }, error => {
      if (error.status === 403) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        this.router.navigate(['/login']);
      } else {
        this.errorSwal.title = error.status;
        this.errorSwal.text = error.error;
        this.errorSwal.show();
        console.log('Error:', error);
      }
    });
  }
  getUsers() {
    this.authenticateService.getUsers().subscribe(res => {
     console.log(res);
     this.users = res.adminUsers;
    }, error => {
      if (error.status === 403) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        this.router.navigate(['/login']);
      } else {
        this.errorSwal.title = error.status;
        this.errorSwal.text = error.error;
        this.errorSwal.show();
        console.log('Error:', error);
      }
    });
  }
  deleteUser(id) {
    if (id === '' || id === undefined) {
      this.errorSwal.title = 'User id alınamadı!';
      this.errorSwal.show();
      return;
    }
    this.spinner.show();
    this.authenticateService.deleteUser(id).subscribe(res => {
      console.log(res);
      this.successSwal.title = 'Başarılı!';
      this.successSwal.show();
      this.getUsers();
      this.spinner.hide();
    }, error => {
      if (error.message === 'Error: Access Denied') {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        this.router.navigate(['/login']);
        this.spinner.hide();
      } else {
        this.errorSwal.title = error.status;
        this.errorSwal.text = error.error;
        this.errorSwal.show();
        this.spinner.hide();
      }
    });
  }

  updateUser(name, username, tfa) {
    if (name === '' || name === undefined || username === '' || username === undefined) {
      this.errorSwal.title = 'Lütfen boş alan bırakmayınız!';
      this.errorSwal.show();
      return;
    }
    this.spinner.show();
    const User = {
      name: name,
      username: username,
      isTfa: tfa !== 'false'
    };

    this.authenticateService.updateUser(User, this.selectedId).subscribe(res => {
      console.log(res);
      this.successSwal.title = 'Başarılı!';
      this.successSwal.show();
      this.closeUpdateModal.nativeElement.click();
      this.getUsers();
      this.spinner.hide();
    }, error => {
      if (error.message === 'Error: Access Denied') {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        this.router.navigate(['/login']);
        this.spinner.hide();
      } else {
        this.errorSwal.title = error.status;
        this.errorSwal.text = error.error;
        this.errorSwal.show();
        this.spinner.hide();
      }
    });
  }
  selected(id, user) {
    this.selectedId = id;
    this.selectedUser = user;
  }
}




// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/users/users.component.ts